import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-button-arrow",
  "use": "tc-svg-button-arrow-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-button-arrow\">\n<path d=\"M1 3.99976L11 3.99976\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M8.14294 1L11.0001 4L8.14294 7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol